import { fetchApi } from "~/lib/api";
import type {
  AdminGetContactMessagesParams,
  ContactFormData,
  ContactMessage,
  ContactMessageResponse,
  Pagination,
} from "~/types";
import { serializeFilterParams } from "./utils";


export const customerContactService = {
  /**
   * Submit a contact form message
   */
  async submitContactForm(
    data: ContactFormData,
  ): Promise<ContactMessageResponse> {
    return fetchApi<ContactMessageResponse>("/anonymous/contact", {
      method: "POST",
      body: JSON.stringify(data),
    });
  },
};

export const adminContactService = {
  /**
   * Get all contact messages (optionally include deleted) with pagination
   */
  async getContactMessages(
    params: AdminGetContactMessagesParams = {},
  ): Promise<Pagination<ContactMessage>> {
    const query = serializeFilterParams(params);
    const endpoint = `/admin/contact-messages${query}`;
    return fetchApi<Pagination<ContactMessage>>(endpoint);
  },

  /**
   * Get a single contact message by ID
   */
  async getContactMessage(id: number): Promise<ContactMessage> {
    return fetchApi<ContactMessage>(`/admin/contact-messages/${id}`);
  },

  /**
   * Delete a contact message (soft delete)
   */
  async deleteContactMessage(
    id: number,
  ): Promise<{ message: string; id: number }> {
    return fetchApi<{ message: string; id: number }>(
      `/admin/contact-messages/${id}`,
      {
        method: "DELETE",
      },
    );
  },

  /**
   * Restore a deleted contact message
   */
  async restoreContactMessage(
    id: number,
  ): Promise<{ message: string; contactMessage: ContactMessage }> {
    return fetchApi<{ message: string; contactMessage: ContactMessage }>(
      `/admin/contact-messages/${id}/restore`,
      {
        method: "POST",
      },
    );
  },

  /**
   * Permanently delete a contact message (hard delete)
   */
  async permanentDeleteContactMessage(
    id: number,
  ): Promise<{ message: string; id: number }> {
    return fetchApi<{ message: string; id: number }>(
      `/admin/contact-messages/${id}/permanent`,
      {
        method: "DELETE",
      },
    );
  },
};
